export { default } from './SoundCheckButton'
